import { apiGateway } from '../api';

async function getFuncoesContrato(numeroContrato) {
    try {
        const response = await apiGateway.get(`/contrato/${numeroContrato}/funcoes`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export { getFuncoesContrato };
